import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit'
import { TagService } from 'services/crm'

const tagsAdapter = createEntityAdapter({
  sortComparer: (a, b) => a.label.localeCompare(b.label),
})

export const fetchTags = createAsyncThunk('crm/tags/fetchAll', async (_, { rejectWithValue }) => {
  try {
    const res = await TagService.getAll()
    return res.data
  } catch (e) {
    return rejectWithValue(e.response?.data?.message || 'Error fetching tags')
  }
})

export const createTag = createAsyncThunk('crm/tags/create', async (data, { rejectWithValue }) => {
  try {
    const res = await TagService.create(data)
    return res.data
  } catch (e) {
    return rejectWithValue(e.response?.data?.message || 'Error creating tag')
  }
})

export const updateTag = createAsyncThunk(
  'crm/tags/update',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await TagService.update(id, data)
      return res.data
    } catch (e) {
      return rejectWithValue(e.response?.data?.message || 'Error updating tag')
    }
  },
)

export const removeTag = createAsyncThunk('crm/tags/remove', async (id, { rejectWithValue }) => {
  try {
    await TagService.remove(id)
    return id
  } catch (e) {
    return rejectWithValue(e.response?.data?.message || 'Error deleting tag')
  }
})

const initialState = tagsAdapter.getInitialState({ loading: 'idle' })

const tagsSlice = createSlice({
  name: 'crmTags',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTags.fulfilled, (state, action) => tagsAdapter.setAll(state, action.payload))
      .addCase(createTag.fulfilled, (state, action) => tagsAdapter.upsertOne(state, action.payload))
      .addCase(updateTag.fulfilled, (state, action) => tagsAdapter.upsertOne(state, action.payload))
      .addCase(removeTag.fulfilled, (state, action) => tagsAdapter.removeOne(state, action.payload))
  },
})

const selectors = tagsAdapter.getSelectors((state) => state.crmTags)
export const selectAllTags = selectors.selectAll
export const selectTagById = selectors.selectById

export default tagsSlice.reducer
